import React, {Suspense} from "react";
import Loader from "../../../components/commons/helpers/loader/loader.component";


function NewStaffingCommonLandingPage({page: {MainContent, breadCrumbList}}) {

    const HeroComponent = React.lazy(() => import('./new-staffing-common-hero-component'));
    const ContentComponent = React.lazy(() => import('./new-staffing-common-content-component'));

    return (
        <div className="general-container">
            <Suspense fallback={<Loader/>}>
                <HeroComponent MainContent={MainContent} breadCrumbList={breadCrumbList}/>
            </Suspense>
            <Suspense fallback={<Loader/>}>
                <ContentComponent MainContent={MainContent}/>
            </Suspense>
        </div>
    );
}

export default NewStaffingCommonLandingPage;
